<template>
  <div>
    <div class="main-wrapper signin-form center signin-wrapper-padding">
	  <div class="text-align-center margin-bottom-20 mm-logo"><img src="@/assets/MM-logo.png" /></div>
	  <h3 class="text-align-center margin-bottom-35">Create Password</h3>
    <flash-message autoHide variant="success"></flash-message>
      <form @submit.prevent="onSubmit">
      <div class="row margin-bottom-15">
        <div class="col-12 col-sm-12">
        <label
            for="password"
            class="col-12">New Password : <span class="required">*</span></label>
        <input
            type="password"
            name="password"
            id="password"
            class="col-12 col-sm-12 input-height-35"
            v-validate="'required|min:10|special_char|number'"
            v-model="password"
            ref="password"
            data-vv-as="Password"
            maxlength="20">
        <div v-show="verrors.has('password')" class="validate-warning-msg">{{ verrors.first('password') }}</div>

        <div 
          class="ml-2 mt-2" 
          :class="password && passwordLengthValid ? 'text-success' : (password && !passwordLengthValid ? 'text-danger' : 'text-muted')" style="margin-left: 0 !important;">
          <i 
            class="fa mr-1" 
            :class="password && passwordLengthValid ? 'fa-check-circle' : (password && !passwordLengthValid ? 'fa-times' : '')"></i>
          10 or more characters
        </div>

        <div 
          class="ml-2" 
          :class="password && containsSpecialChar ? 'text-success' : (password && !containsSpecialChar ? 'text-danger' : 'text-muted')" style="margin-left: 0 !important;">
          <i 
            class="fa mr-1" 
            :class="password && containsSpecialChar ? 'fa-check-circle' : (password && !containsSpecialChar ? 'fa-times' : '')"></i>
          1 or more special characters (*,!,#, etc)
        </div>

        <div 
          class="ml-2 mb-0" 
          :class="password && containsNumber ? 'text-success' : (password && !containsNumber ? 'text-danger' : 'text-muted')" style="margin-left: 0 !important;">
          <i 
            class="fa mr-1" 
            :class="password && containsNumber ? 'fa-check-circle' : (password && !containsNumber ? 'fa-times' : '')"></i>
          1 or more numbers
        </div>
        
        </div>
      </div>
      <div class="row margin-bottom-15">
        <div class="col-12 col-sm-12">
        <label
            for="confirm_password"
            class="col-12">Confirm Password : <span class="required">*</span></label>
        <input
            type="password"
            name="confirm_password"
            id="confirm_password"
            class="col-12 col-sm-12 input-height-35"
            v-validate="'required|confirmed:password|min:6'"
            v-model="confirm_password"
            ref="confirm_password"
            data-vv-as="Confirm password"
            maxlength="20">
        <div v-if="verrors.firstByRule('confirm_password', 'required')" class="margin-bottom-5 validate-warning-msg">
          The Confirm Password field is required</div>
        <div v-if="verrors.firstByRule('confirm_password', 'confirmed')" class="margin-bottom-5 validate-warning-msg">The Password and Confirm Password does not match</div>                  
        </div>
      </div>
        <div class="submit margin-bottom-15 float-right">
            <button type="submit" class="btn btn-info btn-md">Confirm</button>
          </div>

      </form>
    </div>
  </div>
</template>
<style scoped>
.mm-logo img{ width: 240px; }
.text-danger { color: #FF0000 !important; }
</style>
<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import router from '../router/index.js';
import axios from 'axios';
import { store } from '../store/store';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  data: function () {
    return {
      password: '',
      confirm_password: '',
    }
  },
  computed: {
    passwordLengthValid() {
      return this.password.length >= 10;
    },
    containsSpecialChar() {
      return /[!@#$%^&*]/.test(this.password);
    },
    containsNumber() {
      return /[0-9]/.test(this.password);
    }
  },
  methods: {
  	validate() {
  	  this.$validator.validateAll();
      },
  	onSubmit () {
      this.$validator.validateAll().then((result) => {
        if(!result){
          return;
        }
        this.changepassword();
      }).catch(() => {
        // catches the error;
      });

  	},
    navigate(path) {
  	  router.push(path);
  	},
    changepassword: function() {
      axios('/password-update',
        {
          method: 'PATCH',
          data: {password: this.password},
        }
      )
     .then((resp) => {
       this.$store.dispatch('logout');
       this.flash({ message: 'Your password is changed. Please login.', variant: 'success' });
       this.navigate("/login");
      })
     .catch(error => {
        this.$store.dispatch('logout');
        this.navigate("/login");
     });
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/change_password.vue